import {
  ENTITY_HIGHLIGHT_CLASS,
  SKILL_HIGHLIGHT_CLASS,
} from "../ChatInput.constants";

const DECORATION_STYLE_ID = "chat-input-decoration-styles";

/** Injects CSS for decoration highlights into the document head (idempotent) */
export function injectDecorationStyles() {
  if (document.getElementById(DECORATION_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = DECORATION_STYLE_ID;
  style.textContent = `
    .${SKILL_HIGHLIGHT_CLASS} {
      color: #0284c7;
      font-weight: 600;
      background-color: light-dark(#e0f2fe, #0c4a6e);
      padding: 1px 4px;
      border-radius: 4px;
      margin: 0 1px;
    }
    .${ENTITY_HIGHLIGHT_CLASS} {
      color: #7c3aed;
      font-weight: 600;
      background-color: light-dark(#ede9fe, #3b0764);
      padding: 1px 4px;
      border-radius: 4px;
      margin: 0 1px;
    }
  `;
  document.head.appendChild(style);
}
